// extracted by mini-css-extract-plugin
module.exports = {"root":"InlineCTA_root__iJo4b","topBorder":"InlineCTA_topBorder__3nSxW","body":"InlineCTA_body__P1IoY","title":"InlineCTA_title__4bwc1","link":"InlineCTA_link__8ChLa"};